// extracted by mini-css-extract-plugin
export default {"copyButtonText":"CopyButton_copyButtonText__Xm9ul"};